// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hello[data-v-54669304] {\n  background-color: #bbbbbb;\n}\n.v-input--is-label-active label[data-v-54669304] {\n    color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
